import React, { useContext, useEffect } from 'react';
import { Scrollbars } from 'react-custom-scrollbars-2';
import { NotificaçõesContext } from 'contexts/NotificaçõesContext';
import { RelatoriosContext } from 'contexts/RelatoriosContext';
import { VendaContext } from 'contexts/VendaContext';
import { DropsContext } from 'contexts/DropsContext';
import { useDialog } from 'components/Modals';
import Navbar from 'components/Navbar';
import RelatorioModal from 'components/Modals/RelatorioModal';
import Routes from 'routes';

const styles = {
  main: {
    height: '100vh',
  },
  container: {
    padding: '88px 24px 0 24px',
  },
};

const App = () => {
  const { getDrops } = useContext(DropsContext);
  const { getContas } = useContext(VendaContext);
  const { relatorio } = useContext(RelatoriosContext);
  const { getNotifications } = useContext(NotificaçõesContext);
  const { openDialog } = useDialog();

  useEffect(() => {
    getContas();
    getNotifications();
    getDrops([
      'Aplicacao',
      'Ccusto',
      'Cfo',
      'Cfiscal',
      'Cidade',
      'Contribuinte',
      'Defeito',
      'Documento',
      'Equipamento',
      'Entidade',
      'EntidadeTipo',
      'EspecieDocumento',
      'EntidadeEndereco',
      'EspecieDocumento',
      'Filial',
      'FormaDeEnvio',
      'FormaDePagamento',
      'Frota',
      'LocalEstoque',
      'Logo',
      'Marca',
      'Modelo',
      'Modelofiscal',
      'Moeda',
      'NaturezaOperacao',
      'OrigemTributaria',
      'Planoconta',
      'Produto',
      'ProdutoVariacao',
      'Serie',
      'SituacaoTributaria',
      'StatusDocumento',
      'Tecnico',
      'Tributo',
      'UF',
      'UnidadeMedida',
      'Users',
    ]);
  }, []);

  useEffect(() => {
    if (relatorio) {
      openDialog(<RelatorioModal relatorio={relatorio} />, relatorio?.nome);
    }
  }, [relatorio]);

  return (
    <div style={styles.main}>
      <Navbar />
      <Scrollbars>
        <div style={styles.container}>
          <Routes />
        </div>
      </Scrollbars>
    </div>
  );
};

export default App;
